<template>
	<div class="container">
        <div class="">
            <div class="chart_path">
                <div class="base">
                    <div class="time">{{ time }}</div>
                    <div class="date">
                        <p>admin你好</p>
                        <p>{{date}}</p>
                    </div>
                    <div class="flex_1">
                        <el-button class="small" type="danger" >点击进入</el-button>
                    </div>
                </div>
                <div class="chart_box">
                    <div class="item">
                        <div class="label">
                            <p>库存分析</p>
                            <p>实时掌握您的仓库数据</p>
                        </div>
                        <div class="icon_1"></div>
                    </div>
                    <div class="item">
                        <div class="label">
                            <p>出库分析</p>
                            <p>木材销售量尽在掌握中</p>
                        </div>
                        <div class="icon_2"></div>
                    </div>
                    <div class="item">
                        <div class="label">
                            <p>品名分析</p>
                            <p>掌握木材市场的销售方向</p>
                        </div>
                        <div class="icon_3"></div>
                    </div>
                    <div class="item">
                        <div class="label">
                            <p>价格趋势</p>
                            <p>根据市场价格波动对定价进行调整</p>
                        </div>
                        <div class="icon_4"></div>
                    </div>
                </div>
            </div>
            <div class="announcement">
                <p>公告：</p>
                <div class="content">
                    得木云<br>
                    全域数据采集+全量数据多维分析能力,<br>
                    助企业实现数据沉淀+业务增长.更有数据看板<br>
                    ,行为流,渠道归因,用户理解等核心功能,帮助提<br>
                    升企业各职能角色效能。
                </div>
            </div>
        </div>
	</div>
</template>

<style scoped lang="scss">
    .container{
        display: flex; flex-direction: column; align-items: stretch; height: 100%; color: #fff;  overflow: auto; background: url('/icon/charts/bg.png') no-repeat center bottom; background-size: cover; border-top:11px solid #EEEFF2; border-left: 11px solid #EEEFF2;
        & > div{ flex: 1; display: flex; justify-content: center; height: 100%; width: 1808px; padding: 0 50px; padding-top: 82px; }
        p{ padding: 0; margin: 0; }
        .base{
            display: flex; align-items: center; justify-content: space-between; margin-bottom: 22px;
            .flex_1{ text-align: right; }
            .time{ font-size: 54px; color: #FFFFFF; font-weight: bold; }
            .date{
                margin-left: 20px; font-size: 16px; text-align: left;
                & > p + p{ margin-top: 3px; }
            }
        }
        .chart_box{
            display: flex; flex-wrap: wrap; width: 892px;
            .item {
                width:420px; height:190px; background:rgba(255,255,255,0.3); border-radius:3px; display: flex; align-items: center; justify-content: center; color: #fff; line-height: 1; margin: 13px; cursor: pointer;
                .label{
                    text-align: left; width: 210px;
                    & > p:first-child{ font-size: 24px; font-weight: bold; margin-bottom: 8px; }
                    & > p:last-child{ font-size: 14px; }
                }
                &:hover{ background: #FFFFFF; color: #000; margin: 5px; width:436px; height:206px; }
                .icon_1{ background: url('/icon/charts/icon_1.png') no-repeat center; background-size: contain; width: 98px; height: 116px;}
                .icon_2{ background: url('/icon/charts/icon_2.png') no-repeat center; background-size: contain; width: 117px; height: 90px;}
                .icon_3{ background: url('/icon/charts/icon_3.png') no-repeat center; background-size: contain; width: 98px; height: 96px;}
                .icon_4{ background: url('/icon/charts/icon_4.png') no-repeat center; background-size: contain; width: 114px; height: 97px;}
            }
        }
        .announcement{
            width:420px; height:663px; background:rgba(255,255,255,0.3); border:1px solid rgba(112,112,112,1);  border-radius:3px; padding: 35px 20px; color: #fff; text-align: left; line-height: 30px; font-size: 14px; margin-left: 137px;
            & > p{font-size: 16px; margin-bottom: 12px; color: #fff; }
        }
    }
</style>

<script>
export default {
	data() {
		return {
            time : window.moment().format("HH:mm"),
            date : window.moment().format("YYYY-MM-DD        dddd"),
		}
	},
    components:{
    },
	computed:{
	},
	created(){
	},
	mounted(){
        clearInterval(window.interval_obj);
        this.showTime();
	},
	destroyed() {
        clearInterval(window.interval_obj);
	},
	methods: {
        showTime(){
            let self = this;
            window.interval_obj = setInterval(function(){
				self.time =  window.moment().format("HH:mm");
			},60000);

        }
	},
	watch:{
	}
}
</script>
